export default __webpack_public_path__ + "static/media/FLLove.43255200.svg";